import { connect } from "react-redux";
import sanitize from "sanitize-html";

const Table = ({ table }) => {
	const [Headers, ...Rows] = table;
	return (
		<>
			<table className="table-responsive table table-hover">
				<thead>
					<tr>
						{Headers.map((header) => {
							return <th>{header}</th>;
						})}
					</tr>
				</thead>
				<tbody>
					{Rows.map((row) => {
						return (
							<tr>
								{row.map((cell) => {
									return <td>{cell}</td>;
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
		</>
	);
};

const DefaultNotification = ({ forReview, forReviewAgreement, notification, content }) => {
	if (content)
		return (
			<div
				style={{ width: "60%", margin: "auto" }}
				dangerouslySetInnerHTML={{
					__html: sanitize(content?.replaceAll?.("body>", "div>"), {
						allowedAttributes: {
							"*": ["style"],
							"a": ["href", "target"],
						},
						parseStyleAttributes: false,
					}),
				}}
			></div>
		);

	const { table } = forReview || {};
	return <div className="content1">{table ? <Table {...{ table }} /> : null}</div>;
};

const mapStateToProps = (state, ownProps) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultNotification);
